import type { Bridge, BridgeApi } from "./bridge";

export const getBridge = <T extends Bridge>(bridge: T): BridgeApi[T] => {
	return globalThis[bridge];
};
